import { useLocation, useRevalidator } from '@remix-run/react'
import { useCallback, useState } from 'react'
import { Button, Card, CardBody } from 'reactstrap'
import { clientHints, useHints } from '#app/utils/client-hints.tsx'

function setConsentAcceptedCookie() {
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? '; Secure'
      : ''
  document.cookie = `${clientHints.consent.cookieName}=true; path=/; max-age=31536000; SameSite=Lax${secure}`
}

/** Web share link / app promo: `/clube/desafios/:matchId` (not `novo` / `editor`). */
function isPublicMatchPromoPage(pathname: string) {
  const m = pathname.match(/^\/clube\/desafios\/([^/]+)\/?$/)
  if (!m) return false
  const segment = m[1]
  return segment !== 'novo' && segment !== 'editor'
}

/** DM email / universal link landing: `/clube/conversa/:username`. */
function isPublicConversaPromoPage(pathname: string) {
  return /^\/clube\/conversa\/[^/]+\/?$/.test(pathname)
}

/** Profile share / universal link: `/clube/perfil/:username`. */
function isPublicProfilePromoPage(pathname: string) {
  return /^\/clube\/perfil\/[^/]+\/?$/.test(pathname)
}

/** Teacher share / universal link: `/clube/professor/:username`. */
function isPublicProfessorPromoPage(pathname: string) {
  return /^\/clube\/professor\/[^/]+\/?$/.test(pathname)
}

/** Ranking share / universal link: `/clube/ranking/:slug`. */
function isPublicRankingPromoPage(pathname: string) {
  return /^\/clube\/ranking\/[^/]+\/?$/.test(pathname)
}

/** Public “open in app” landings — no cookie banner (same as desafio share). */
function isPublicAppLinkLandingPage(pathname: string) {
  return (
    isPublicMatchPromoPage(pathname) ||
    isPublicConversaPromoPage(pathname) ||
    isPublicProfilePromoPage(pathname) ||
    isPublicProfessorPromoPage(pathname) ||
    isPublicRankingPromoPage(pathname)
  )
}

export function ConsentBanner() {
  const location = useLocation()
  const { revalidate } = useRevalidator()
  const hints = useHints()
  const [dismissed, setDismissed] = useState(false)

  const onAccept = useCallback(() => {
    setConsentAcceptedCookie()
    setDismissed(true)
    void revalidate()
  }, [revalidate])

  if (isPublicAppLinkLandingPage(location.pathname)) return null
  if (hints['consent'] === 'true' || dismissed) return null

  return (
    <div
      className="fixed-bottom mb-3 mx-3 mx-md-auto w-md-50 w-lg-25"
      style={{
        /* Above .app-landing-page .hero-content (z-index 3–5) and mobile menu (1040); align with $zindex-toast */
        zIndex: 1090,
      }}
    >
      <Card className="shadow-lg">
        <CardBody className="p-3">
          <p className="text-center fs-6">
            Utilizamos cookies para garantir que você obtenha a melhor
            experiência em nossa plataforma. Ao utilizar nosso serviço, você
            está de ciente e concorda com seu uso.
          </p>
          <div className="d-flex justify-content-center">
            <Button
              type="button"
              color="primary"
              className="w-100"
              onClick={onAccept}
            >
              Entendi
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
